import { AbstractCommand } from 'src/models/command';

class SavePersonalMemoCommand extends AbstractCommand {
	readonly name = 'IFS_DesktopModule_Memo_Command_Commands_SaveThePersonalMemoForTheUser';

	public constructor(text: string, width: number, height: number) {
		super();
		this.parameters = {
			height,
			text,
			width,
		};
	}
}

export { SavePersonalMemoCommand };
